import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { MapLayer } from 'ff/debrief/models';
import { useMapControls, useAnalytics } from 'ff/debrief/hooks';
import Divider from '@mui/material/Divider';

const chartOptions = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentUser = (window as any).currentUser;
    const charts: { id: MapLayer; name: string }[] = [
        { id: 'street', name: 'Street Map' },
        { id: 'aerial', name: 'Aerial Map' },
    ];
    if (!currentUser) {
        return charts;
    }
    if (currentUser.data_us) {
        charts.push(
            { id: 'us/vfr', name: 'U.S. VFR' },
            { id: 'us/ifrlow', name: 'U.S. IFR (low)' },
            { id: 'us/ifrhigh', name: 'U.S. IFR (high)' }
        );
    }
    if (currentUser.data_ca) {
        charts.push(
            { id: 'ca/vnc', name: 'Canada VNC' },
            { id: 'ca/ifrlow', name: 'Canada IFR (low)' },
            { id: 'ca/ifrhigh', name: 'Canada IFR (high)' }
        );
    }
    if (currentUser.data_eu) {
        charts.push(
            { id: 'eurocontrol/vfr', name: 'Europe VFR' },
            { id: 'eurocontrol/ifrlow', name: 'Europe IFR (low)' },
            { id: 'eurocontrol/ifrhigh', name: 'Europe IFR (high)' }
        );
    }
    return charts;
};

interface LayerSettingsProps {
    closeHandler: () => void;
}

export const LayerSettings: React.FC<LayerSettingsProps> = props => {
    const { logMapLayerChanged } = useAnalytics();
    const { closeHandler } = props;
    const memoizedChartOptions = React.useMemo(chartOptions, []);
    const {
        currentLayer,
        aeroLayer,
        setLayer,
        toggleAero: toggleAeroLayer,
    } = useMapControls();

    const handleLayerClick = (layer: MapLayer) => {
        setLayer(layer);
        closeHandler();
        logMapLayerChanged({
            layerName: layer,
        });
    };
    return (
        <>
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {(window as any).currentUser && (
                <MenuItem
                    key={'aeronautical-layer'}
                    onClick={() => toggleAeroLayer()}
                    selected={aeroLayer}
                >
                    Aeronautical
                </MenuItem>
            )}
            <Divider />
            {memoizedChartOptions.map(o => {
                return (
                    <MenuItem
                        key={o.id}
                        onClick={() => handleLayerClick(o.id)}
                        selected={currentLayer === o.id}
                    >
                        {o.name}
                    </MenuItem>
                );
            })}
        </>
    );
};
